module.exports = __webpack_public_path__ + "static/img/welcome_screen.2010032.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/my-irish-date/welcome_screen.png
// module id = 9IBs
// module chunks = 0